<template>
    <div :class="['componentContainer', { single: imageLength == 1, multiple: imageLength > 1 }]">
        <div class="image-layout d-flex justify-content-center align-content-center">
            <span v-if="loading" class="m-auto position-absolute spinner-border top-50"></span>
            <img class="lozad"
            height="236"
            width="236"
            style="min-width: 200px;"
            :src="loadFile('logo.png')"
            :data-src="imageOb.url"
            alt=""
            v-if="imageLength == 1"
            @load="onImageLoad"
            @click="() => toggleModal(0, imageOb.url)"  />
        </div>
        <!-- unused -->
        <!-- <div class="imageContainer" v-if="imageLength == 2">
            <img @click="() => toggleModal(index, image)" v-for="(image, index) in testImages" :key="image" :src="image"
                height="118" width="118" />
        </div> -->
        <!-- unused -->
        <!-- <div class="imageContainer" v-if="imageLength > 2">
            <div class="countContainer">
                <img @click="() => toggleModal(1, testImages[1])" :src="testImages[1]" height="118" width="118" />
                <span class="count">{{ imageLength - 1 }}+</span>
            </div>
            <img @click="() => toggleModal(0, testImages[0])" :src="testImages[0]" height="118" width="118" />
        </div> -->
    </div>
    <div class="messageContent fs-14px" v-if="imageOb.caption">{{ imageOb.caption }}</div>
    <ImagePreview @update:isModalOpen="toggleModal" :personName="message.profile_name ?? ''" :time="''"
        :currentImage="selectedImage" :images="listImageOb" :currentIndex="selectedImageIndex" :isModalOpen="isModalOpen" />
</template>
<script setup>
import { computed, ref,onMounted } from 'vue'
import ImagePreview from "@/components/whatsapp-managment/includes/types/ImagePreview.vue"
import { loadFile } from '@/components/utils.js'
import lozad from 'lozad'

const props = defineProps({
    message: {
        type: Object,
        default: () => ({}),
        required: true,
    },
});
const isModalOpen = ref(false)
const selectedImage = ref('')
const selectedImageIndex = ref(-1)
const toggleModal = (index = -1, image = '') => {
    selectedImage.value = image
    selectedImageIndex.value = index
    isModalOpen.value = !isModalOpen.value
}

const content = 'A brand new message'
const imageLength = computed(()=>{
    if(!props.message)
    return 0;
    // calc length image
    // return props.message.content.url;
    return 1;
})
const imageOb=computed(()=>{
    if(!props.message)
    return {
        url:null,
        caption:null
    };
    return {
        // url:`${process.env.MIX_STORAGE_URL}\\${props.message.content.image.url}`,
        url:`${props.message.content.image.url}`,
        caption:props.message.content.image.caption
    };
})
const listImageOb=computed(()=>{
    // handle multi image
    if(!props.message)
    return [
    ];
    return [
    {
        url:`${props.message.content.image.url}`,
        caption:props.message.content.image.caption
    }
    ];
})
onMounted(()=>{
    const observer = lozad('.lozad', {
    rootMargin: '10px 0px',
    threshold: 0.1,
    enableAutoReload: true
});
observer.observe();
const base_url= window.location.origin;

});
// loading
const loading = ref(true);

const onImageLoad = () => {
  loading.value = false;
};
</script>

<style scoped lang="scss">
@import './styles/image.scss';


</style>
